




























































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import SignInForm from '@/components/signIn/SignInForm.vue'
import SignUpForm from '@/components/signUp/SignUpForm.vue'
import { EventBus } from '@/main'
import { IcoachCategoriesEnum, IcoachCourse, IcoachUserInfo, MainLogosTypes } from '@/interfaces'
import IcoachService from '@/services/IcoachService'
import IcoachLocalStorageHelper from '@/utils/IcoachLocalStorageHelper'
import IcoachHelper from '@/utils/IcoachHelper'
import UserService from '@/services/UserService'

@Component({
  name: 'WelcomePage',
  components: {
    SignInForm,
    SignUpForm
  }
})
export default class WelcomePage extends Vue {
  @Getter('user/isAuthenticated')
  isAuthenticated!: boolean

  @Prop({})
  accessCode!: string

  displayedForm: string = 'signUp'
  icoachUserInfo!: IcoachUserInfo
  icoachCourse: IcoachCourse | null = null
  signInLinkId = 'sign-in-link-in-welcome'
  error: string = ''
  tabIndex: number = 0

  async created () {
    try {
      const response = await IcoachService.getIcoachCourseInfo(this.accessCode)
      this.icoachCourse = response

      this.$store.commit('mainLogo/setLogos', response.logos)
      this.$store.commit('mainLogo/setType', MainLogosTypes.ICOACH_LOGOS)

      IcoachHelper.checkIcoachCourse(response)

      if (!this.isAuthenticated && this.icoachCourse) {
        EventBus.$emit('languageChanged', this.icoachCourse.defaultLanguage)
      }

      EventBus.$on('authorizedComplete', async () => {
        await this.beginIcoach()
      })
    } catch (error) {
      if (error instanceof TypeError) {
        this.error = error.message
      } else {
        this.$router.push({ name: 'notFound' })
      }
    }
  }
  async mounted () {
    let signInLink = document.querySelector(`#${this.signInLinkId}`)
    if (signInLink) {
      signInLink.addEventListener('click', (): void => { this.changeForm('signIn') })
    }
  }
  async beginIcoach () {
    if (!this.icoachCourse) {
      return
    }

    try {
      IcoachHelper.checkIcoachCourse(this.icoachCourse)
    } catch (error) {
      this.error = error.message
      return
    }

    this.icoachUserInfo = await IcoachService.getIcoachUser(
      this.icoachCourse!.id,
      this.accessCode
    ) || await IcoachService.createIcoachUser(
      this.icoachCourse!.id,
      this.accessCode
    )

    this.$store.commit('icoach/setIcoachInfo', {
      'userId': this.icoachUserInfo.id,
      'icoachCourse': this.icoachCourse
    })

    let storageIcoachUserInfo = IcoachLocalStorageHelper.getIcoachUser(
      this.icoachUserInfo.id
    )
    if (!storageIcoachUserInfo) {
      storageIcoachUserInfo = {
        icoachAccessCode: this.accessCode,
        icoachCourseId: this.icoachCourse!.id,
        icoachUserId: this.icoachUserInfo.id,
        icoachCourseTitle: this.icoachCourse!.title,
        icoachSkillCategoryId: IcoachCategoriesEnum.SOFT_SKILLS
      }
    }

    IcoachLocalStorageHelper.beginIcoach(storageIcoachUserInfo)

    this.$router.push({
      name: 'icoach.dashboard',
      params: {
        icoachUserId: this.icoachUserInfo.id.toString()
      }
    })
  }

  changeForm (formName: string) {
    if (formName === 'signIn') {
      this.tabIndex = 1
    } else {
      this.tabIndex = 0
    }
  }
}
